export class ListPagingSetMaxPagesAction {
  constructor(public maxPages: number) {
  }
}
